module.exports = __webpack_public_path__ + "img/footer_icon_Instagram.707fb0b8.svg";